export default "__VITE_ASSET__6fe0e60b__"